import ProgressBar from "@components/common/ui/ProgressBar";
import { Text } from "@components/common/ui/Text";
import ReactLoading from "react-loading";
import { Background, Container, ProgressWrapper } from "./styles";

interface LoaderProps {
  loading: boolean;
  progress?: number;
}
export default function Loader({ loading, progress }: LoaderProps) {
  return (
    <Container loading={loading}>
      <Background />
      {!!progress ? (
        <ProgressWrapper>
          <Text variant={"blue"} weight={"medium"}>
            Por favor aguarde, {progress}% carregado...
          </Text>
          <ProgressBar progress={progress} />
        </ProgressWrapper>
      ) : (
        <ReactLoading type="spinningBubbles" color={"#0152F8"} height={40} width={40} className="loader-spin" />
      )}
    </Container>
  );
}
